import p5 from 'p5';
import gsap from 'gsap';
import Blob from './blob';
import Fighter, {getFighterPositions} from './fighters';
import Tube, {preload} from './tube';
import Data from './data';
import { random } from 'gsap/all';

let totalFighters = 500;
let currentFights = 400;

let blob;
let tube;
let fighters = [];
let bullets = [];
let safetyRingAroundBlob = 50;

let gameState = 'loading';
let textFadeAmount = 0;

window.setup = () => {
	createCanvas(window.innerWidth, window.innerHeight);
	
	frameRate(30);
	randomSeed(1);
	p5.disableFriendlyErrors = true;
	document.title = "FIGHT THE BLOB!!!!!";

	const gameInfo = new Data(onDataFinish, onError);
	tube = new Tube();
}

const onDataFinish = ({supply, purchased, idsOwnedByUser, names}) => {
	//supply = 100;
	totalFighters = supply;
	currentFights = purchased > supply/8 ? purchased : supply/8;
	blob = new Blob(currentFights / totalFighters, safetyRingAroundBlob, whenBlobDies);
	
	const fighterPositions = getFighterPositions(currentFights, width, height, safetyRingAroundBlob);

	const fighterSize = currentFights < 50 ? 20 : currentFights < 150 ? 12 : 6;
	fighters = fighterPositions.map((pos, i) => new Fighter(pos, idsOwnedByUser.includes(i), names[i], whenFighterDies, fighterSize));
	gameState = 'intro'; 
	tube.animateIn(startGame);
}

const onError = () => {
	const supply = random(100, 200);
	onDataFinish({
		supply,
		purchased: supply - random(10, 50),
		idsOwnedByUser: [],
		names: []
	});
}

const whenBlobDies = () => {
	gameState = 'we-wins';
	fighters.forEach(fighter => {
			fighter.beginCelebrating();
	});
}

const startGame = () => {
	fighters.forEach(fighter => {
		fighter.intro();
	});
	gameState = 'bringInFighters';
	setTimeout(() => startFight(), 1500);
}

const startFight = () => {
	gameState = 'fighting';
	tube.beginFade();
	fighters.forEach(fighter => {
		fighter.beginFighting();
	});
}

const whenFighterDies = (name) => {
	const markup = document.createElement("p");
	markup.classList.add('death-name');
	markup.innerHTML = `${name || 'UNKNOWN'} died`;
	document.querySelector('.death-list').appendChild(markup);
	gsap.to(markup, {opacity: 0, duration:1, delay: .25});
	gsap.to(markup, {height: 0, duration:.5, delay: 1});
}

window.draw = () => {
	background(211, 70, 87);
	noStroke();
	tube.draw();

	if(gameState === 'loading') {
		return;
	}

	if(blob.diameter > width*1.5) {
		gameState = 'blob-wins';
	}
	
	if(gameState === 'bringInFighters') {
		fighters.forEach(fighter => {
			fighter.draw();
		});
	}
	else if(gameState === 'fighting') {
		fighters.forEach(fighter => {
			fighter.updateLife(blob.bounds);
			if(fighter.canFire) {
				const newBullet = fighter.fireBullet();
				if(newBullet) {
					bullets.push(newBullet);
				}
			}
			fighter.draw();
		});
	
		bullets.filter(bullet => !bullet.dead).forEach(bullet => {
			const isHit = bullet.draw(blob.x, blob.y, blob.bounds);
			if(isHit) {
				blob.getHit();
			}
		});
		blob.draw();
	}
	else if(gameState === 'blob-wins') {
		background(10, 10, 10);
		fill(255, 255, 255, textFadeAmount);
		textAlign(CENTER);
		textSize(64);
		textFont('VT323');
		text('BLOB WINZ',  width/2, height/2);
		textSize(24);
		text('NEED MORE FIGHTERZ',  width/2, height/1.75);
		textFadeAmount+=2;
	}
	else if(gameState === 'we-wins') {
		fighters.forEach(fighter => {
			fighter.draw();
		});
		blob.draw();
		background(211, 70, 87, 0 + textFadeAmount-50);
		fill(255, 255, 255, textFadeAmount);
		textAlign(CENTER);
		textSize(64);
		textFont('VT323');
		text('WE WINZ!!!',  width/2, height/2);
		textSize(24);
		text('THNX 4 PLAYING',  width/2, height/1.75);
		
		if(textFadeAmount < 255) {
			textFadeAmount+=2;
		}
	}
}

const copyToMain = () => {
	let mockPxl = width / width * pixelSize;
	for(let x = 0; x < width; x+=mockPxl) {
		for(let y = 0; y < height; y+=mockPxl) {
			const px = get(x, y);
			fill(...px);
			const tX = (x / width) * width; 
			const tY = (y / height) * height;
			rect(tX, tY, pixelSize);
		}
	}
}
